/**
 * SSE stream helper for the Copilot chat. Parses `event: session` and
 * `data: …` frames from a fetch Response body and dispatches to the
 * caller-provided handlers. Keeps the useCopilotChat hook focused on
 * conversation state.
 */
function handleEvent(rawEvent, { onSession, onChunk }) {
  if (rawEvent.includes("event: session")) {
    const sid = rawEvent.split("\n").find((l) => l.startsWith("data: "))?.slice(6);
    if (sid) onSession(sid);
    return;
  }
  const line = rawEvent.split("\n").find((l) => l.startsWith("data: "));
  if (!line) return;
  const data = line.slice(6);
  if (data === "[DONE]") return;
  onChunk(data);
}

export async function streamCopilotChat({ apiBase, message, sessionId, onSession, onChunk }) {
  const res = await fetch(`${apiBase}/api/copilot/chat`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, session_id: sessionId }),
  });
  if (!res.ok || !res.body) {
    const err = await res.text().catch(() => "Error");
    return { ok: false, error: `[${res.status}] ${err.slice(0, 200)}` };
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop() || "";
    for (const ev of events) handleEvent(ev, { onSession, onChunk });
  }
  return { ok: true };
}
